import { fileUtils } from "../../utils";

const uploadFile = async (url, binaryFile) => {
  const response = await fetch(url, {
    method: "PUT",
    body: binaryFile
  });

  return response;
};

const fetchFile = async (url) => {
  const response = await fetch(url, {
    method: "GET"
  });

  return response;
};

const downloadFile = async (fileUrl, type) => {
  if (fileUrl) {
    const res = await fetchFile(fileUrl);

    if (res) {
      const blob = await res.blob();

      if (blob) {
        const file = fileUtils.getFileBlob(blob, type);
        const fileSrc = URL.createObjectURL(file);

        return { file, fileSrc };
      }
    }
  }
};

/**
 * Service for uploading and downloading files to and from S3 signed url
 */
const s3FileService = {
  uploadFile,
  downloadFile
};

export default s3FileService;
